export default __webpack_public_path__ + "static/media/blog-xl-1.d258f639.png";